import { render, staticRenderFns } from "./Digest.vue?vue&type=template&id=51cc54ba"
import script from "./Digest.vue?vue&type=script&lang=js"
export * from "./Digest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports